
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetopanchganicabfare() {



  const cardData =
  {
    keyword: ' Pune to Panchgani Cab Fare',
    heading: 'Vaishnavi Travels: Pune to Panchgani Cab Fare',
    headingDescription: 'Vaishnavi Travels offers affordable and reliable Pune to Panchgani Cab Fare services, ensuring a smooth and scenic journey to the popular hill station. Our cabs are well-maintained with comfortable seating, strong air-conditioning, and ample luggage space, providing a stress-free ride for families, friends, and corporate travelers. With experienced chauffeurs, punctual pickups, and flexible booking options, we make your Pune to Panchgani trip comfortable and convenient. Whether it’s a weekend getaway, honeymoon, or leisure holiday, Vaishnavi Travels guarantees safe, dependable, and cost-effective cab services at the best fare from Pune to Panchgani.',

    top: 'Top Places to Visit in Panchgani with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Table Land",
    "description": "Table Land, Asia’s second-largest plateau, is Panchgani’s most famous attraction. Spread over 95 acres, it offers stunning views of valleys, hills, and rivers. Horse rides and local snacks add charm to the visit. In monsoon, the plateau turns lush green, while sunsets here are magical. It is also a popular shooting location for Bollywood films. Table Land is Panchgani’s natural wonder and adventure hotspot."
  },
  {
    "title": "Sydney Point",
    "description": "Sydney Point is a breathtaking viewpoint in Panchgani offering panoramic views of the Krishna Valley, Dhom Dam, and Kamalgad Fort. Tourists enjoy peaceful evenings here with cool breezes and colorful skies. It is especially popular for photography at sunrise and sunset. Couples and families love the serene environment. The spot provides a perfect blend of calmness and beauty. Sydney Point is Panchgani’s scenic retreat."
  },
  {
    "title": "Parsi Point",
    "description": "Parsi Point is a picturesque viewpoint overlooking the Krishna Valley and the sparkling waters of Dhom Dam. It is named after the Parsi community who loved visiting the spot. Families enjoy picnics, photography, and roadside snacks here. The views are especially enchanting during monsoon with mist and waterfalls. It is easily accessible and great for short halts. Parsi Point is Panchgani’s family-friendly scenic attraction."
  },
  {
    "title": "Devrai Art Village",
    "description": "Devrai Art Village is a creative hub in Panchgani where local artisans craft eco-friendly art using metal, stone, wood, and bamboo. Tourists can watch live demonstrations and buy souvenirs like décor, jewelry, and sculptures. The initiative supports tribal communities while promoting sustainable living. The peaceful surroundings enhance the experience. Art lovers and culture seekers find it highly inspiring. Devrai Art Village is Panchgani’s cultural and artistic gem."
  },
  {
    "title": "Rajpuri Caves",
    "description": "Rajpuri Caves, located 10 km from Panchgani, are ancient caves associated with Pandavas from the Mahabharata. Surrounded by sacred kunds (ponds), the caves are considered holy for purification rituals. A temple dedicated to Lord Kartikeya adds to the spiritual significance. Pilgrims visit during festivals and rituals. The caves also offer a glimpse into India’s mythology. Rajpuri Caves are Panchgani’s sacred and historic treasure."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden, located between Panchgani and Mahabaleshwar, is a must-visit for strawberry lovers. Visitors enjoy fresh strawberry shakes, ice creams, and fruit-based desserts. The garden also houses a chocolate factory, nursery, and food court. The annual Strawberry Festival attracts huge crowds with music and unlimited tastings. Families shop for syrups, jams, and juices here. Mapro Garden is Panchgani’s sweet paradise of flavors."
  },
  {
    "title": "Dhom Dam",
    "description": "Dhom Dam, located on the Krishna River near Panchgani, is a scenic reservoir surrounded by green hills. Tourists enjoy boating, water sports, and photography here. It is a favorite stop for adventure seekers and families. During monsoon, the dam overflows, creating breathtaking views. Bollywood movies have also been shot here. Dhom Dam is Panchgani’s refreshing natural getaway."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall, situated between Panchgani and Mahabaleshwar, is a spectacular cascade falling from 600 feet. Surrounded by dense forests, it looks stunning in monsoon. Tourists can view the main fall from afar or enjoy smaller waterfalls nearby. It is popular for trekking, nature walks, and photography. The cool mist makes it refreshing during summer too. Lingmala Waterfall is Panchgani’s monsoon jewel of nature."
  },
  {
    "title": "Harrison’s Folly",
    "description": "Harrison’s Folly is a flat mountain top offering panoramic views of Panchgani, Wai, and the Krishna Valley. Tourists enjoy jeep rides, horse rides, and local food stalls here. The spot is known for its wide-angle photography opportunities. Sunsets from here are particularly stunning. Families and couples love the open-air vibe. Harrison’s Folly is Panchgani’s adventurous scenic point."
  },
  {
    "title": "Kamalgad Fort",
    "description": "Kamalgad Fort, located near Panchgani, is a historic hill fort surrounded by steep cliffs. Trekkers hike through dense forests to reach the top, which offers mesmerizing views of valleys and Dhom Dam. The fort has ancient ruins and a mysterious well believed to have a secret origin. Adventure seekers enjoy the challenging trek. The fort is less crowded, making it peaceful. Kamalgad is Panchgani’s hidden adventure and history spot."
  }
],


  "services": [
    {
      "name": "Pune to Panchgani Taxi Fare Estimate",
      "description": "Get an estimated fare for taxi travel from Pune to Panchgani. Transparent pricing that includes tolls and driver allowances to help you plan your trip budget ahead."
    },
    {
      "name": "AC Cab Pune Panchgani",
      "description": "Travel in cool comfort with our air‑conditioned taxi service from Pune to Panchgani. Ideal for long drives, these AC cabs offer plush interiors and smooth rides."
    },
    {
      "name": "Round Trip Cab Panchgani",
      "description": "Convenient round‑trip cab services between Pune and Panchgani, with flexible timings, stops along the way, and trusted drivers experienced on this route."
    },
    {
      "name": "One Way Cab to Panchgani",
      "description": "One‑way taxi services from Pune to Panchgani (or vice versa), ideal for travelers with onward travel plans. Transparent charges and reliable ride."
    },
    {
      "name": "Budget Fare Panchgani Taxi",
      "description": "Cost‑effective taxi services to Panchgani at budget‑friendly fares. Best for solo travelers or small groups who want safe travel without high costs."
    },
    {
      "name": "SUV Cab for Panchgani Trip",
      "description": "Premium SUV taxi rentals for trips from Pune to Panchgani, offering more space and comfort — great for families or groups wanting a premium travel experience."
    },
    {
      "name": "Family Taxi Pune Panchgani",
      "description": "Family‑oriented taxi services from Pune to Panchgani, ensuring spacious vehicle options and a comfortable trip for children and elders alike."
    },
    {
      "name": "Online Fare Checker Panchgani Cab",
      "description": "Use our online fare checker to get instant fare estimates for cabs to Panchgani from Pune. Plan ahead with confidence."
    },
    {
      "name": "Corporate Cab Panchgani Pune",
      "description": "Professional cab services designed for corporate travelers between Panchgani and Pune. Punctual, comfortable, with executive vehicle options."
    },
    {
      "name": "Weekend Getaway Cab Fare",
      "description": "Special cab packages and fare deals for weekend trips to Panchgani from Pune. Enjoy scenic drives, leisure stops, and relaxed schedules."
    },
    {
      "name": "Panchgani Tour Cab Booking",
      "description": "Hire a cab for Panchgani sightseeing tours. Includes pickup, dropper, and planned stops at major attractions around Panchgani."
    },
    {
      "name": "Pune Panchgani Mini Cab Fare",
      "description": "Mini cab services between Pune and Panchgani at economical fares — perfect for budget travelers wanting basic but reliable transport."
    },
    {
      "name": "Private Taxi Fare Pune to Panchgani",
      "description": "Private taxi option offering door to door service from Pune to Panchgani, with privacy and flexibility. Ideal for those who prefer personalized travel."
    }
  ],
  "tableData": [
    ["Pune to Panchgani Taxi Fare Estimate", "AC Cab Pune Panchgani"],
    ["Round Trip Cab Panchgani", "One Way Cab to Panchgani"],
    ["Budget Fare Panchgani Taxi", "SUV Cab for Panchgani Trip"],
    ["Family Taxi Pune Panchgani", "Online Fare Checker Panchgani Cab"],
    ["Corporate Cab Panchgani Pune", "Weekend Getaway Cab Fare"],
    ["Panchgani Tour Cab Booking", "Pune Panchgani Mini Cab Fare"],
    ["Private Taxi Fare Pune to Panchgani"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Panchgani Cabs",
    "WhyChoosedescription": "Vaishnavi Travels provides comfortable and reliable cab services from Pune to Panchgani, ideal for weekend trips, family outings, and group travel."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Select from Swift Dzire, Ertiga, Innova, Urbania, and Tempo Traveller according to your group size and comfort needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced and thoroughly cleaned to ensure your journey is safe and hygienic."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers know the best routes from Pune to Panchgani to provide a smooth, timely, and pleasant travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer all-inclusive fares covering fuel, tolls, parking, and driver allowances with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy door-to-door pickup and drop-off from your home, hotel, or office in Pune and your preferred spot in Panchgani."
  },
  {
    "WhyChooseheading": "Perfect for Leisure and Group Trips",
    "WhyChoosedescription": "Ideal for families, friends, and corporate groups wanting to explore the scenic beauty of Panchgani comfortably."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to help with bookings, itinerary planning, and travel questions."
  }
]

















  }




const faqData = [
  [
    {
      question: 'What is the typical fare for a cab from Pune to Panchgani?',
      answer: 'Fares usually start at around ₹3,200 one‐way for a sedan like Swift Dzire. Prices vary based on the vehicle type, travel time, and whether you need a return trip or multiple stops.',
    },
    {
      question: 'What types of cabs are available from Pune to Panchgani?',
      answer: 'We offer options such as Swift Dzire, Ertiga, Innova, and Tempo Traveller, so you can choose based on your group size and comfort preference.',
    },
    {
      question: 'Is the fare for Pune to Panchgani fixed or does it change?',
      answer: 'The fare can vary depending on factors like traffic, road conditions, pick‐up point in Pune, and whether it’s a one‐way or round trip. Peak seasons may also affect pricing.',
    },
    {
      question: 'Can I get a round trip fare estimate from Pune to Panchgani?',
      answer: 'Yes — we provide round trip options with transparent pricing. You’ll get a quote based on vehicle, stay duration, and any sightseeing stops you’d like.',
    },
    {
      question: 'Does the quoted fare include tolls, parking, and driver allowance?',
      answer: 'Yes, all our fare estimates include toll fees, parking, and driver’s allowance, so there are no hidden costs.',
    },
    {
      question: 'How far in advance should I book a cab for the Pune to Panchgani route?',
      answer: 'It’s best to book at least 1–2 days ahead, especially during weekends, holidays, and during the strawberry festival, to ensure vehicle availability.',
    },
    {
      question: 'Is doorstep pickup and drop offered for Pune to Panchgani cab?',
      answer: 'Yes — we provide pickup and drop service from your location anywhere in Pune, along with drop‐off in Panchgani at your convenience.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Saurabh Kulkarni",
    position: "Weekend Traveller",
    feedback: "Booked a cab from Pune to Panchgani with Vaishnavi Travels — the service was on time, the vehicle clean, and the ride comfortable despite the hilly roads. Worth every rupee!",
    rating: 5,
  },
  {
    name: "Ms. Neha Desai",
    position: "Group of Friends",
    feedback: "We took an Innova through Vaishnavi Travels for a day trip to Panchgani. Very smooth journey, friendly driver, and the fare matched what was promised. Highly recommend!",
    rating: 5,
    style: "style-2",
  }
];













































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const fareSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiFare",
  "name": "Pune to Panchgani Cab Fare",
  "description": "Check estimated taxi fares from Pune to Panchgani for AC and Non-AC cabs, round trips, one-way rides, family trips, corporate travel, and weekend getaways. Affordable and reliable cab fare estimates online.",
  "estimatedCost": {
    "@type": "MonetaryAmount",
    "currency": "INR"
  },
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "url": "https://vaishnavitravel.com/pune-to-panchgani-cab-fare"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Cab Fare Services Pune to Panchgani",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Taxi",
          "name": "AC Cab Pune to Panchgani"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Taxi",
          "name": "Non-AC Cab Pune to Panchgani"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Taxi",
          "name": "SUV Cab Pune to Panchgani"
        }
      }
    ]
  },
  "url": "https://vaishnavitravel.com/pune-to-panchgani-cab-fare"
};




  return (
    <div>

<Helmet>
  <title>Pune to Panchgani Cab Fare | Taxi Fare Estimate & Booking</title>
  <meta
    name="description"
    content="Check estimated taxi fares from Pune to Panchgani for AC and Non-AC cabs, round trips, one-way rides, family trips, corporate travel, and weekend getaways. Affordable and reliable cab fare estimates online."
  />
  <meta
    name="keywords"
    content="Pune to Panchgani Taxi Fare Estimate, AC Cab Pune Panchgani, Round Trip Cab Panchgani, One Way Cab to Panchgani, Budget Fare Panchgani Taxi, SUV Cab for Panchgani Trip, Family Taxi Pune Panchgani, Online Fare Checker Panchgani Cab, Corporate Cab Panchgani Pune, Weekend Getaway Cab Fare, Panchgani Tour Cab Booking, Pune Panchgani Mini Cab Fare, Private Taxi Fare Pune to Panchgani"
  />
  <script type="application/ld+json">
    {JSON.stringify(fareSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopanchganicabfare;